import locale_en from "./translations/en.json";
import locale_es from "./translations/es.json";

export const translations = {
    'es': locale_es,
    'en': locale_en
};